// Request a password-reset link. The server returns an identical generic
// message on every branch, so this view never reports whether the address
// matched an account.

import { ApiClientError, forgotPassword } from '../api/client.js';
import { type View } from '../router.js';
import { el } from '../dom.js';
import { devPanel } from './devPanel.js';

export const forgotView: View = (outlet) => {
  const error = el('p', { class: 'form-error', hidden: true });
  const submit = el('button', { type: 'submit', class: 'btn' }, 'Send reset link');

  const email = el('input', {
    id: 'email',
    name: 'email',
    type: 'email',
    required: true,
    autocomplete: 'email',
    inputmode: 'email',
    placeholder: 'you@example.com',
  }) as HTMLInputElement;

  const honeypot = el('input', {
    name: 'website',
    type: 'text',
    tabindex: -1,
    autocomplete: 'off',
    style: 'position:absolute;left:-9999px;width:1px;height:1px;',
    'aria-hidden': 'true',
  }) as HTMLInputElement;

  const form = el('form', { method: 'post', action: '/forgot', novalidate: true }, [
    el('label', { for: 'email' }, 'Email'),
    email,
    honeypot,
    error,
    submit,
  ]) as HTMLFormElement;

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    error.hidden = true;
    submit.setAttribute('disabled', 'disabled');
    try {
      const { message, devResetUrl } = await forgotPassword({
        email: email.value.trim(),
        website: honeypot.value || undefined,
      });
      outlet.replaceChildren(
        el('main', { class: 'auth-card' }, [
          el('h1', {}, 'Check your inbox'),
          el('p', {}, message),
          ...devPanel({ url: devResetUrl, linkText: 'Open the reset link' }),
          el('p', {}, [el('a', { href: '/login' }, 'Back to log in')]),
        ]),
      );
    } catch (err) {
      error.textContent =
        err instanceof ApiClientError ? err.message : 'Something went wrong. Try again.';
      error.hidden = false;
      submit.removeAttribute('disabled');
    }
  });

  outlet.append(
    el('main', { class: 'auth-card' }, [
      el('h1', {}, 'Reset your password'),
      form,
      el('p', {}, [el('a', { href: '/login' }, 'Back to log in')]),
    ]),
  );
};
